<template>
  <div id="navigation">
    <div class="nav-group main">
      <router-link v-if="currentUser" :to="{ name: 'home' }" class="nav-item"> Home </router-link>
      <router-link :to="{ name: 'invoices' }" class="nav-item" v-if="currentUser && organisation"> Invoices </router-link>
      <router-link :to="{ name: 'clients' }"  class="nav-item" v-if="currentUser && organisation"> Clients </router-link>
      <router-link :to="{ name: 'settings' }" class="nav-item" v-if="currentUser && organisation"> Settings </router-link>
      <router-link :to="{ name: 'admin' }"    class="nav-item" v-if="currentUser && isAdmin"> Admin </router-link>
    </div>
    <div class="nav-group user">
      <router-link  v-if="currentUser" to="profile" class="nav-item">{{
        currentUser.displayName
      }}</router-link>
      <button class="nav-item logout" @click="logout"><i class="far fa-power-off"></i></button>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Navigation",
  props: ['organisation'],
  computed: {
    currentUser() {
      return this.$store.getters.currentUser;
    },
    isAdmin() {
      return this.currentUser.admin
    }
  },
  methods: {
    logout() {
      this.$store.commit("SET_CURRENT_USER", null)
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace("login");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
#navigation {
  display: flex;
  justify-content: space-between;
  box-shadow: 1px 1px 4px rgba(0,0,0,0.2);
  .nav-group {
    display: flex;
  }
  .nav-item {
    color: var(--color-theme);
    text-decoration: none;
    display: block;
    padding: 20px 15px;
    margin: 6px;
    border-radius: 4px;
    &:hover {
      background: rgba(var(--color-theme-values), 0.1);
    }
    &.router-link-active {
      background: var(--color-theme);
      color: white;
    }
  }
  .logout {
    outline: none;
    border: none;
    background-color: transparent;
    font-size: 20px;
    padding: 0 20px;
    color: $color-danger;
    cursor: pointer;
    &:hover {
      background: $color-danger;
      color: white;
    }
  }
}

@media print {
  #navigation {
    display: none;
  }
}

</style>
